import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { faUserPlus, faUserSlash } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { GlobalSearchModal } from "@/components/GlobalSearchModal/GlobalSearchModal";

import { ListPerson } from "@/pages/Private/pages/List/schema/list";
import { useFindLeadForProspect } from "@/pages/Private/pages/List/utils/columns/useFindLeadForProspect";

// Feed-card name slot for placeholder ("SELECT" / "Person not found") prospects that have no real
// contact yet. Mirrors the SelectProspectCell flow (same hook + GlobalSearchModal) but with the
// feed look from the mockup: a "No contact yet" header and a "Find leads" call to action.
export const NoContactYet: FunctionComponent<{ row: ListPerson }> = ({ row }) => {
	const { t } = useTranslation();
	const { companyName, companyDomain, showSearchModal, setShowSearchModal, handleConfirm } =
		useFindLeadForProspect(row);

	return (
		<div className="flex flex-col gap-1 items-start" onClick={(e) => e.stopPropagation()}>
			<div className="flex flex-row items-center gap-1.5 text-text-meta text-sm font-medium">
				<Icon className="w-3.5 h-3.5" icon={faUserSlash} />
				{t("messages.noContactYet")}
			</div>
			<Button
				color={ButtonColor.BRAND}
				image={<Icon className="mr-2" icon={faUserPlus} />}
				size={ButtonSize.XS}
				title={t("messages.findLeads")}
				onClick={(e) => {
					e.stopPropagation();
					setShowSearchModal(true);
				}}
			/>
			{showSearchModal && (
				<GlobalSearchModal
					singleSelect
					confirmLabel={t("list.selectProspect")}
					initialFilterCompany={
						companyDomain ? { name: companyName, domain: companyDomain } : undefined
					}
					isOpened={showSearchModal}
					setIsOpened={setShowSearchModal}
					onConfirmSelection={handleConfirm}
				/>
			)}
		</div>
	);
};
